<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import LayoutHeader from "./header/index.vue";
import LayoutMenu from "./menu/index.vue";
import LayoutMain from "./main/index.vue";
import { useGlobalStore } from "@/stores/global";

const globalStore = useGlobalStore();
const route = useRoute();
// 判断是否显示 Menu
const hideMenu = computed(() => {
    return route.meta.hideMenu;
});
</script>

<template>
    <div class="app">
        <LayoutHeader />
        <div class="layout-content" :class="{ 'aside-expand': globalStore.isCollapse, 'hide-menu': hideMenu }">
            <LayoutMenu v-if="!hideMenu" />
            <LayoutMain />
        </div>
    </div>
</template>

<style scoped lang="scss">
.app {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: #f9f9f9;
    min-width: var(--zh-layout-min-width);
    .layout-content {
        display: flex;
        width: 100%;
        min-width: var(--zh-layout-min-width);
        height: calc(100vh - var(--zh-layout-header));
        // padding: 16px;
        box-sizing: border-box;
        gap: 8px;
        .row {
            flex: 1;
            margin-left: 16px;
            display: flex;
            justify-content: center;
            align-content: flex-start;
            overflow-y: auto;
            :deep {
                & > .detail-container {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }
            }
        }
    }
}
</style>
